/**
 * Designed to take in an amount,
 * and return that amount formatted to be a USD value
 * 
 * @param {float} amount 
 * @returns {string}
 * @example
 * convertToDollar(1234.56); // $1,234.56
 */
const convertToDollar = (amount) => {
    const formattedAmount = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    }).format(amount);
    return formattedAmount;
};

export default convertToDollar;
